import React from "react";
import Preloader from "../helper/Preloader";
//
import HeaderOne from "../components/UI/HeaderOneMain";
import FooterOne from "../components/UI/FooterOneMain";
import BottomFooter from "../components/UI/BottomFooterMain";
import HomeProductCategory from "../components/UI/ProductFeatureCategory";
// import ShippingOne from "../components/ShippingOne";
//
import BannerOne from "../components/UI/BannerMain";
// import FeatureOne from "../components/FeatureOne";
// import PromotionalOne from "../components/PromotionalOne";
// import FlashSalesOne from "../components/FlashSalesOne";
// import ProductListOne from "../components/ProductListOne";
// import OfferOne from "../components/OfferOne";
// import RecommendedOne from "../components/RecommendedOne";
// import HotDealsOne from "../components/HotDealsOne";
// import TopVendorsOne from "../components/TopVendorsOne";
// import BestSellsOne from "../components/BestSellsOne";
// import DeliveryOne from "../components/DeliveryOne";
// import OrganicOne from "../components/OrganicOne";
// import ShortProductOne from "../components/ShortProductOne";
// import BrandOne from "../components/BrandOne";
// import NewArrivalOne from "../components/NewArrivalOne";
// import NewsletterOne from "../components/NewsletterOne";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import ShippingOneMain from "../components/UI/ShippingOneMain";

const DashboardMain = () => {
  // const host = new URL(window.location.href)?.host ?? "";

  // if (host === "localhost:3001") {
  //   return (
  //     <>
  //       <HeaderOne />
  //       <h1 className="text-danger">INTERFACE 1</h1>
  //     </>
  //   );
  // }

  // if (host === "localhost:3002") {
  //   return (
  //     <>
  //       <HeaderOne />
  //       <h1 className="text-warning">INTERFACE 2</h1>
  //     </>
  //   );
  // }

  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#299E60" />

      {/* ColorInit */}
      <ColorInit color={false} />

      {/* HeaderOne */}
      <HeaderOne />

      {/* BannerOne */}
      <BannerOne />

      {/* NewArrivalOne */}
      <HomeProductCategory
        categoryName={"Best Sellers"}
        param={"sortBy"}
        category={"bestsellers"}
        extraParams={{ onlyBestSeller: true }}
      />

      {/* NewArrivalOne */}
      <HomeProductCategory
        categoryName={"Deal of The Day"}
        param={"sortBy"}
        category={"dealoftheday"}
        extraParams={{ onlyDealOfTheDay: true }}
      />

      {/* NewArrivalOne */}
      <HomeProductCategory
        categoryName={"Newest Arrivals"}
        param={"sortBy"}
        category={"newest"}
        extraParams={{ OnlyNewestArrival: true }}
      />

      {/* FeatureOne */}
      {/* <FeatureOne /> */}

      {/* PromotionalOne */}
      {/* <PromotionalOne /> */}

      {/* FlashSalesOne */}
      {/* <FlashSalesOne /> */}

      {/* ProductListOne */}
      {/* <ProductListOne /> */}

      {/* OfferOne */}
      {/* <OfferOne /> */}

      {/* RecommendedOne */}
      {/* <RecommendedOne /> */}

      {/* HotDealsOne */}
      {/* <HotDealsOne /> */}

      {/* TopVendorsOne */}
      {/* <TopVendorsOne /> */}

      {/* BestSellsOne */}
      {/* <BestSellsOne /> */}

      {/* DeliveryOne */}
      {/* <DeliveryOne /> */}

      {/* OrganicOne */}
      {/* <OrganicOne /> */}

      {/* ShortProductOne */}
      {/* <ShortProductOne /> */}

      {/* BrandOne */}
      {/* <BrandOne /> */}

      {/* ShippingOne */}
      <ShippingOneMain />

      {/* NewsletterOne */}
      {/* <NewsletterOne /> */}

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default DashboardMain;
